module.exports = __webpack_public_path__ + "static/media/CS2 -- FinalUI__4.3ad722ce.jpg";